import React, { useContext, useEffect, useRef, useState } from "react";
import styles from "./StickyFiles.module.scss";
import MobileContext from "../../context/mobile";
import StickyContext from "../../context/sticky";

const StickyFiles = (props) => {
  const isMobile = useContext(MobileContext);
  const { height } = props;
  const refContainer = useRef(null);
  const refWrap = useRef(null);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    const container = refContainer.current;
    const wrap = refWrap.current;
    const scrollHandler = () => {
      let currentProgress = 0;
      if (wrap.getBoundingClientRect().top < 0 && wrap.getBoundingClientRect().bottom - window.innerHeight > 0) {
        currentProgress = (-wrap.getBoundingClientRect().top / (wrap.offsetHeight - window.innerHeight)) * 100;
      } else if (wrap.getBoundingClientRect().top >= 0) {
        currentProgress = 0;
      } else {
        currentProgress = 100;
      }
      setProgress(currentProgress);
    }
      let options = {
        threshold: 0.0,
        rootMargin: '0% 0% 0% 0%'
      }
      const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            scrollHandler();
            document.addEventListener('scroll', scrollHandler);
          } else {
            document.removeEventListener('scroll', scrollHandler);
            scrollHandler();
          }
        })
      }, options);
      observer.observe(container);
    
    const setMargins = () => {
      let margin = (window.innerHeight - container.children[0].children[0].offsetHeight) / 2;
      container.style.marginTop = -margin + 'px';
      wrap.style.marginBottom = -margin + 'px';
      if (isMobile) {
        container.style.marginTop = '';
        wrap.style.marginBottom = '';
      }
    }
    setMargins();
    window.addEventListener('resize', setMargins);
    window.addEventListener('resize', scrollHandler);
    return () => {
      document.removeEventListener('scroll', scrollHandler);
      window.removeEventListener('resize', setMargins);
      window.removeEventListener('resize', scrollHandler);
      observer.unobserve(container);
    }
  }, [isMobile]);

  let items = [];

  if (props.children !== undefined) {
    if (typeof props.children === 'object' && props.children.length > 1) {
      props.children.forEach((element, index) => {
        items.push(<div className={styles.item} key={`item-${index}`}>{element}</div>);
      });
    } else {
      items.push(<div className={styles.item}>{props.children}</div>);
    }
  }
  let heightStyle = height;
  if(height === undefined || height === '' || isMobile){
    heightStyle=null;
  }
  return (
    <>
      <StickyContext.Provider value={progress}>
        <div className={styles.wrap} ref={refWrap} >
          <div className={styles.container} ref={refContainer} style={{ 'height': heightStyle }}>
            {/* {props.children} */}
            {items}
          </div>
        </div>
      </StickyContext.Provider>
    </>
  );

}

export default StickyFiles;
